<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />
        <div v-if="!loading">
          <crud-list
            ref="crudListFornecedor"
            v-model="fornecedores"
            :headers="headers"
            :actions="actions"
            :permission="'list_fornecedor'"
            :sort-by="['cnpj']"
            :sort-desc="[false]"
            :slots="[
              'item.status',
              'item.telefones',
              'item.tmp',
            ]"
            :export-pdf-xlsx="true"
          >
            <template
              v-if="hasPermission('inserir_fornecedor')"
              v-slot:btnCadastro
            >
              <v-col>
                <v-btn
                  class="text-none text-white"
                  block
                  rounded
                  color="primary"
                  title="Cadastrar novo fornecedor"
                  @click="$router.push({ path: 'fornecedores/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
            <template
              v-if="hasPermission('ativar_fornecedor')"
              v-slot:[`item.status`]="{ item }"
            >
              <v-checkbox
                v-model="item.status"
                color="success"
                class="mt-0"
                :readonly="!hasPermission('ativar_fornecedor')"
                :loading="false"
                hint="Ativar/Desativar fornecedor!"
                hide-details
                @change="TOGGLE_FORNECEDOR_STATUS(item)"
              />
            </template>
            <template v-slot:[`item.telefones`]="{ item }">
              <div
                v-for="(telefone, index) in item.telefones"
                :key="index"
              >
                <span v-if="telefone">
                  {{ `${index + 1}:  ${telefone}` }}
                  <br>
                </span>
              </div>
            </template>
            <template v-slot:[`item.tmp`]="{ item }">
              <v-tooltip
                v-if="!(item.eventos.length > 0)"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>Fornecedor sem eventos</span>
              </v-tooltip>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import FornecedoresStore, { BOOTSTRAP, INATIVAR_FORNECEDOR, TOGGLE_FORNECEDOR_STATUS } from '@/store/modules/fornecedores'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    props: {
      cnpjs: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        actions: [
          {
            title: 'Editar',
            color: 'info darken-3',
            click: item => this.getFornecedor(item),
            icon: 'mdi-pencil',
            permission: 'editar_fornecedor',
          },
          {
            title: 'Excluir',
            color: 'red darken-3',
            click: item => this.INATIVAR_FORNECEDOR(item),
            icon: 'mdi-trash-can-outline',
            permission: 'excluir_fornecedor',
          },
        ].filter(action => store.getters.hasPermission(action.permission)),
        headers: [
          { text: '', value: 'actions', sortable: false, groupable: false, width: '40px' },
          { align: 'center', sortable: false, groupable: false, text: 'Status', value: 'status', width: '40px', floatingfilter: true, report: true, styleReport: { status: true } },
          { align: 'center', sortable: false, groupable: false, text: '', value: 'tmp', width: '40px', floatingfilter: false },
          { align: 'center', sortable: true, groupable: false, text: 'Código', value: 'codigo', width: '10px', floatingfilter: true, report: true, styleReport: { halign: 'right' } },
          { align: 'left', sortable: true, groupable: false, text: 'CPF/CNPJ', value: 'cpf_cnpj', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Nome/Razão Social', value: 'nome_razao_social', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Nome Fantasia', value: 'nome_fantasia', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Email', value: 'email', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: false, groupable: false, text: 'Telefones', value: 'telefones', width: 'auto', report: true },
          { align: 'left', sortable: true, groupable: true, text: 'Papel', value: 'roles.description', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Logradouro', value: 'endereco.logradouro', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Número', value: 'endereco.numero', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Complemento', value: 'endereco.complemento', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Bairro', value: 'endereco.bairro', width: 'auto', floatingfilter: true },
          { align: 'left', sortable: true, groupable: true, text: 'Cidade', value: 'endereco.cidade.nome', width: 'auto', floatingfilter: true },
          { align: 'left', sortable: true, groupable: true, text: 'Estado', value: 'endereco.estado.sigla', width: 'auto', floatingfilter: true },
          { align: 'left', sortable: true, groupable: false, text: 'CEP', value: 'endereco.cep', width: 'auto' },
        ],
      }
    },
    computed: {
      ...mapState('fornecedores', ['loading', 'fornecedores']),
      ...mapGetters(['hasPermission']),
    },
    async created () {
      if (!this.$store.hasModule('fornecedores')) { this.$store.registerModule('fornecedores', FornecedoresStore) }
      this.BOOTSTRAP()
    },
    updated () {
      if (this.cnpjs) {
        this.filterCnpj(this.cnpjs)
      }
    },
    methods: {
      ...mapActions('fornecedores', [BOOTSTRAP, INATIVAR_FORNECEDOR, TOGGLE_FORNECEDOR_STATUS]),
      filterCnpj (cnpj) {
        const arrayCnpjs = JSON.parse(cnpj)
        let elemento
        for (let i = 0; i <= arrayCnpjs.length; i++) {
          elemento = this.$refs.crudListFornecedor.filters.cpf_cnpj.indexOf(arrayCnpjs[i])
          if (this.$refs.crudListFornecedor.filters.cpf_cnpj && elemento === -1) {
            this.$refs.crudListFornecedor.filters.cpf_cnpj.push(arrayCnpjs[i])
          } else {
            this.$refs.crudListFornecedor.filters.cpf_cnpj.splice(elemento, 1)
          }
        }
      },
      getFornecedor ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/fornecedores/alterar`,
          query: { id },
        })
      },
    },
  }
</script>
